var $ = require('jquery');
var menu = {
    navActive: false,
    init: function () {
        this.bindUIActions();
        this.setupAria();
    },
    bindUIActions: function () {
        // $( window ).on('load', function() {
        //     // If a menu item has children (or a sub-menu), inject an "expansion arrow" for accessibility after the link in the menu item's link.
        //     $( '.menu-item-has-children > a' ).each(function(){
        //         var menuText = $(this).text();
        //         var menuId = 'submenu-' + menuText.replace(/[^a-z0-9\s-]/ig,'').trim().replace(/\s+/g, '-').toLowerCase();
        //         $(this).next().attr('id', menuId);
        //         $(this).after( '<button class="expand-submenu-button" aria-label="'+menuText+' Menu" aria-controls="'+menuId+'" aria-expanded="false"><i class="far fa-chevron-up"></i></button>' );
        //     });
        // });        
        $('.nav-toggle').on('click', function () {
            menu.toggleNav();
        });
        $(window).on('resize', function () {
            if(menu.navActive == true && $(window).outerWidth() > 1090){
                menu.closeNav();
            }
        });
        $(document).on('click', '.sub-menu-wrapper', function (evt) {
            evt.stopPropagation();
            menu.toggleSubNav($(this));
        });
        $('li.menu-item-has-children > a').on('mouseenter', function () {
            console.log('moused over');
            menu.openAria($(this));
        });
        $('li.menu-item-has-children > a').on('mouseleave', function () {
            console.log('moused out');
            menu.closeAria($(this));
        });
    },
    addTabIndex: function(){
        $('main *, footer *').attr('tabindex', '-1');
    },
    removeTabIndex: function(){
        $('main *, footer *').removeAttr('tabindex');
    },
    openNav: function(){
        $('.header').addClass('active');
        $('.header-nav').addClass('active');
        menu.addTabIndex();
        menu.navActive = true;        
    },
    closeNav: function(){
        $('.header').removeClass('active');
        $('.header-nav').removeClass('active');
        menu.removeTabIndex();
        menu.navActive = false;        
    },
    toggleNav: function () {
        if($('.header').hasClass('active')){
            menu.closeNav();
        } else {
            menu.openNav();
        }
    },
    toggleSubNav: function (el) {
        var subMenu = el.find('> .sub-menu');
        // console.log(subMenu);
        if (subMenu.hasClass('touch-open')) {
            // opened by clicking the parent on mobile device
            subMenu.removeClass('touch-open');
            menu.closeAria(subMenu);
        } else {
            subMenu.addClass('touch-open');
            menu.openAria(subMenu);
        }
    },
    setupAria: function () {
        $('.sub-menu-wrapper').each(function () {
            $(this).attr('aria-hidden', true).attr('aria-expanded', false);
        });
    },
    openAria: function (el) {
        el.parents().find('.sub-menu-wrapper').attr('aria-hidden', false).attr('aria-expanded', true);
    },
    closeAria: function (el) {
        el.parents().find('.sub-menu-wrapper').attr('aria-hidden', true).attr('aria-expanded', false);
    }
};
module.exports = menu;





// init: function() {
//     mmt = this.settings;
//     this.bindUIActions();
//     // console.log('MainMenuTabbing functionality loaded!');
// },

// bindUIActions: function() {
//     // On window load or resize
//     $(window).on ( 'load resize', function() {
//         // Remove any injected styles into sub-menu elements
//         $( '.main-menu > .menu-item > .sub-menu' ).attr( 'style', '' );

//         if ( $(window).width() >= 1201 ) {
//             $('.expand-submenu-button').removeClass('expanded').blur();
//         }
//     });

//     $( window ).on( 'load', function() {
//         // If a menu item has children (or a sub-menu), inject an "expansion arrow" for accessibility after the link in the menu item's link.
//         $( '.menu-item-has-children > a' ).each(function(){
//             var menuText = $(this).text();
//             var menuId = 'submenu-' + menuText.replace(/[^a-z0-9\s-]/ig,'').trim().replace(/\s+/g, '-').toLowerCase();
//             $(this).next().attr('id', menuId);
//             $(this).after( '<button class="expand-submenu-button" aria-label="'+menuText+' Menu" aria-controls="'+menuId+'" aria-expanded="false"><i class="far fa-chevron-up"></i></button>' );
//         });
//     });

//     // When interacted with (clicked)
//     $( document ).on( 'click', '.expand-submenu-button', function( event ) {
//         event.preventDefault();
//         // The expand button that was clicked will take on a new class of expanded and will open the sub-menu (via css).
//         if ( $( this ).hasClass('expanded') ) {
//             $( this ).removeClass('expanded');
//             $( this ).attr('aria-expanded', 'false');
//         } else {
//             $('.expand-submenu-button').removeClass('expanded');
//             $( this ).toggleClass('expanded');
//             $( this ).attr('aria-expanded', 'true');
//         }
//     });

//     // When interacted with (key pressed)
//     $( document ).on( 'keydown', '.expand-submenu-button.expanded', function( event ) {
//         // If 'tab key'
//         if ( event.which === 9 ) {
//             // If 'shift key'
//             if( event.shiftKey ) {
//                 $( this ).parents( '.main-menu' ).find( '.expand-submenu-button.expanded' ).toggleClass( 'expanded' );
//             }
//         }
//     });

//     // When the last menu item is focused and the tab key is pressed, it should close the menu.
//     $( document ).on( 'keydown', '.sub-menu .menu-item:last-child', function( event ) {
//         // If 'tab key'
//         if ( event.which === 9 ) {
//             // If 'shift key'
//             if( event.shiftKey ) {
//                 // Do nothing.
//             } else {
//                 // Prevent the default behavior.
//                 event.preventDefault();
//                 // Find the parents of '.sub-menu .menu-item:last-child' and add or remove the expanded class.
//                 $( this ).parents( '.main-menu' ).find( '.expand-submenu-button.expanded' ).toggleClass( 'expanded' );
//             }
//         }
//     });

//     // When the first menu item is focused and the shift and tab keys are pressed together, it should close the menu.
//     $( document ).on( 'keydown', '.sub-menu .menu-item:first-child', function( event ) {
//         // If 'tab key'
//         if ( event.which === 9 ) {
//             // If 'shift key'
//             if( event.shiftKey ) {
//                 // Prevent the default behavior.
//                 event.preventDefault();
//                 // Find the parents of '.sub-menu .menu-item:last-child' and add or remove the expanded class.
//                 $( this ).parents( '.main-menu' ).find( '.expand-submenu-button.expanded' ).toggleClass( 'expanded' );
//             }
//         }
//     });
// },